export enum Provider {
    MERCADOLIBRE = 'MERCADOLIBRE',
    AMAZON = 'AMAZON'
}

export const ProviderOptions = {
    [Provider.MERCADOLIBRE]: Provider.MERCADOLIBRE,
    [Provider.AMAZON]: Provider.AMAZON
}